import { render } from "./be-a-model.vue?vue&type=template&id=3af3d64a&scoped=true"
import script from "./be-a-model.vue?vue&type=script&lang=js"
export * from "./be-a-model.vue?vue&type=script&lang=js"

import "./be-a-model.vue?vue&type=style&index=0&id=3af3d64a&lang=scss&rel=stylesheet%2Fscss"
import "./be-a-model.vue?vue&type=style&index=1&id=3af3d64a&lang=scss&rel=stylesheet%2Fscss&scoped=true"
script.render = render
script.__scopeId = "data-v-3af3d64a"

export default script